import { CartLinesUpdateEvent, CartErrorEvent } from '@shopify/events';

/**
 * "Complete your look" in the cart drawer: the Add to cart button of an offer adds that product and refreshes the
 * drawer through the same events the theme's own add to cart uses.
 */

const BUTTON = '.cart-upsell__add';

async function addOffer(/** @type {HTMLElement} */ button) {
  const id = Number(button.dataset.variantId);
  if (!id) return;

  const sections = [...document.querySelectorAll('cart-items-component')]
    .map((component) => (component instanceof HTMLElement ? component.dataset.sectionId : ''))
    .filter(Boolean)
    .join(',');

  const deferred = CartLinesUpdateEvent.createPromise();
  button.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: [{ merchandiseId: String(id), quantity: 1 }],
      promise: deferred.promise,
    })
  );

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id, quantity: 1 }], sections }),
    });
    const result = await response.json();
    if (!response.ok || result.status) throw new Error(result.description || result.message || 'Add to cart failed');

    const cart = await (await fetch('/cart.js')).json();
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: {
        items: cart.items,
        source: 'plum-upsell',
        sourceId: 'plum-upsell',
        itemCount: 1,
        productId: String(button.dataset.productId ?? ''),
        sections: result.sections,
        didError: false,
      },
    });
  } catch (error) {
    deferred.reject(error);
    button.dispatchEvent(
      new CartErrorEvent({ error: error instanceof Error ? error.message : 'Add to cart failed', code: 'INVALID' })
    );
  }
}

document.addEventListener('click', async (event) => {
  const target = event.target instanceof Element ? event.target : null;
  const button = target?.closest(BUTTON);
  if (!(button instanceof HTMLElement) || button.dataset.busy === 'true') return;

  button.dataset.busy = 'true';
  button.setAttribute('aria-busy', 'true');
  try {
    await addOffer(button);
  } finally {
    button.dataset.busy = 'false';
    button.removeAttribute('aria-busy');
  }
});
